import { render, staticRenderFns } from "./QuestionSimpleView.vue?vue&type=template&id=7dfee142&scoped=true&"
import script from "./QuestionSimpleView.vue?vue&type=script&lang=js&"
export * from "./QuestionSimpleView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSimpleView.vue?vue&type=style&index=0&id=7dfee142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfee142",
  null
  
)

export default component.exports